import cx from 'classnames';
import * as React from 'react';

import Icon, { IconColor, IconName, IconSize } from 'components/Icon';
import MediaObject from 'components/MediaObject';
import Text, { OptionalProps as TextProps } from 'components/Text';
import { MediaObjectGutter } from 'components/MediaObject';
import './styles/TextWithIcon.scss';

export type Props = {
  underline?: boolean;
  appendIcon?: boolean;
  center?: boolean;
  children?: React.ReactNode;
  className?: string;
  gutter?: MediaObjectGutter;
  baseline?: boolean;
  icon?: IconName; // If undefined, space is held where an icon would be
  iconClassName?: string;
  iconColor?: IconColor;
  iconSize?: IconSize;
  inline?: boolean;
  subtextColor?: TextProps['color'];
  subtext?: string;
} & TextProps;

export default function TextWithIcon(props: Props) {
  const {
    appendIcon,
    center = true,
    children,
    className,
    gutter = 'xsmall',
    baseline,
    icon,
    iconClassName,
    iconColor = 'currentColor',
    iconSize = 'medium',
    inline,
    lineHeight = 'flush',
    subtext,
    subtextColor = 'graphite',
    ...others
  } = props;

  const iconComponent = (
    <Icon
      ariaHidden
      className={iconClassName}
      color={iconColor}
      name={icon ?? null}
      size={iconSize}
    />
  );

  const subTextComponent = subtext && (
    <Text
      color={subtextColor}
      size="xsmall"
      truncate
      align="inherit"
      className="TextWithIcon--subtext"
    >
      {subtext}
    </Text>
  );

  const textComponent = (
    <Text {...others} align="left" lineHeight={lineHeight}>
      {children}
    </Text>
  );

  return (
    <>
      <MediaObject
        center={center}
        figure={appendIcon ? 'right' : 'left'}
        gutter={gutter}
        inline={inline}
        baseline={baseline}
        className={cx('TextWithIcon', className)}
      >
        {appendIcon ? textComponent : iconComponent}
        {appendIcon ? iconComponent : textComponent}
      </MediaObject>
      {subTextComponent}
    </>
  );
}
